import React from 'react';
import Skeleton from '@mui/material/Skeleton';

function TableSkeletonRow() {
  return (
    <tr style={{ height: '3rem' }}>
      <td style={{ padding: '0.5rem', border: 'none' }} className="date">
        <Skeleton width="70%" height="1.5rem" />
      </td>
      <td style={{ padding: '0.5rem', border: 'none' }} className="label">
        <Skeleton variant="text" width="70%" height="1.5rem" />
      </td>
      <td style={{ padding: '0.5rem', textAlign: 'right', border: 'none' }} className="points">
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Skeleton width="70%" height="1.5rem" />
        </div>
      </td>
    </tr>
  );
}

function TableSkeletonRows({ rows = 5 }: { rows?: number }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <TableSkeletonRow key={i} />
      ))}
    </>
  );
}

export function RewardsWonTableSkeleton({ rows = 7 }: { rows?: number }) {
  return (
    <section
      className="qlfeditor-rewards-won__table--skeleton qlf-skeleton"
      style={{ overflowX: 'auto' }}
      data-testid="skeleton"
      role="status"
      aria-live="polite"
      // not translated as this is backend rendered and while we have the locale at hand, it's not handy to make i18next work with SSR
      aria-label="Loading rewards history"
    >
      <Skeleton height="2rem" width="100%" sx={{ marginBottom: '0.5rem' }} variant="rectangular" />
      <table className="qlf-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
        <colgroup>
          <col style={{ width: '30%' }} />
          <col style={{ width: '50%' }} />
          <col style={{ width: '20%' }} />
        </colgroup>
        <tbody>
          <TableSkeletonRows rows={rows} />
        </tbody>
      </table>
    </section>
  );
}
